import { UISref } from "@uirouter/react";
import PropTypes from "prop-types";
import React from "react";
import classNames from "classnames";

import { Icon } from "../../Common/Icon";

const ActionsListCell = ({ id, onClick, className }) => (
  <div role="cell" className={classNames("sorted-list__data --right-icon", className)}>
    <UISref to="edit-notification" params={{ notificationId: id }}>
      <button className="button__actions --active">
        <Icon id="edit" className="button__actions-icon --large --first" />
      </button>
    </UISref>
    <button className="button__actions --active" onClick={onClick}>
      <Icon id="delete" className="button__actions-icon --large" />
    </button>
  </div>
);

ActionsListCell.propTypes = {
  id: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string
};

ActionsListCell.defaultProps = {
  className: ""
};

export default ActionsListCell;



// WEBPACK FOOTER //
// ./src/components/Notifications/List/ActionsListCell.js